// @flow
import React from 'react'
import {setCombatantValue} from '../../../redux-actions/battle-actions.js'
import {handleAnimationEnd, clearArenaAnimations, timeout} from './animation-lifecycle-utilities'
import store from '../../../init/store'

class AnimationSlice extends React.Component {

  props: {
    casterId: string,
    targetIds: Array<string>,
  };

  state: {
    hasTriggeredAnimation: boolean
  };

  constructor() {
    super();
    this.state = {
      hasTriggeredAnimation: false
    }
  }

  async runAnimationSeries() {

    /* ----------- */ await timeout(200);

    //Fire the blade animation
    this.setState({
      hasTriggeredAnimation: true
    });

    /* ----------- */ await timeout(100);

    //Tell each target to go OUCH
    this.props.targetIds.forEach(targetId => {
      setCombatantValue(targetId, {
        animationCssRule: "shake 0.3s infinite"
      });
    });

    /* ----------- */ await timeout(300);

    //Stop target shaking
    this.props.targetIds.forEach(targetId => {
      setCombatantValue(targetId, {
        animationCssRule: "none"
      });
    });


    //Clear the background stuff
    clearArenaAnimations();


    /* ----------- */ await timeout(200);

    //Move on to next step
    handleAnimationEnd();


  }

  componentDidMount() {
    this.runAnimationSeries();
  }

  render() {

    return (
      <div>
        {
          this.props.targetIds.map((targetId, i) => {
            const targetModel = store.getState().battle.combatants[targetId];
            //Get the Left, Top, W, H of the target person.
            const {left, top, width, height} = targetModel.boundingClientRect;

            //Create a style block out of that
            const style = {
              position: "absolute",
              background: "url(/images/animations/battle/slice-animation.svg) no-repeat no-repeat",
              backgroundSize: "cover",
              zIndex: 3,
              backgroundPosition: this.state.hasTriggeredAnimation ? `${parseInt(width,10) * -4}px 0%` : "0% 0%",
              left,
              top,
              width,
              height,
              transition: "background-position 0.3s steps(4)"
            };
            return <div key={i} style={style} />;
          })
        }
      </div>
    )
  }
}

export default AnimationSlice;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/animation-components/AnimationSlice.js